import { initOfficeHoverReveal } from "../component/office-hover-reveal.js";
import { scrollToSection } from "../component/scroll-to-section.js";
import { initCookieBar,initDmcabadge,initGooglePreferredSource } from "../component/bottom-cookie-bar.js";
import initMobileMenu from "../component/mobile-menu.js";
import { initContextMenu } from "../component/disable-rightclick.js";
import { initGlowWrapper } from "../component/glow.js";

initContextMenu();
initDmcabadge();
initCookieBar();
initOfficeHoverReveal();
scrollToSection();
initMobileMenu();
initGooglePreferredSource();

document.addEventListener("DOMContentLoaded", () => {
    initGlowWrapper();
});
